export const WELCOME_STEPS_COUNT = 4;
